// removed by extract-text-webpack-plugin
module.exports = {"apple-pay":"PriceBarSub__apple-pay","applePay":"PriceBarSub__apple-pay"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBarSub/PriceBar.scss
// module id = 2227
// module chunks = 8